<app-table
  [perPageOptions]="perPageOptions"
  emptyText="{{ 'no_courses_found' | translation }}"
  [hasBorders]="false"
  [hasAlternatingRows]="false"
  [rows]="rows"
  [isProcessing]="isLoading"
  [isLoading]="initialLoad"
  [columns]="columns"
  [showPaginator]="true"
  [itemCount]="itemCount"
  [perPage]="perPage"
  [pageNumber]="pageNumber"
  [sortBy]="sortBy"
  [sortAsc]="sortAsc"
  [canSearch]="true"
  [filterInput]="filterInput"
  (initSearch)="handleSearch($event)"
  (setPageCount)="setPageCount($event)"
  (sortChange)="sortChange($event)"
  (activePageChange)="activePageChange($event)">
  <div table-search>
    <app-input-dropdown
      class="input-dropdown"
      [placeholder]="'select_status' | translation"
      [control]="statusControl"
      [options]="statusOptions"></app-input-dropdown>
  </div>
</app-table>
